<template>
	<TextInput
		:id="id"
		:name="name"
		type="tel"
		:value="value"
		:label="label"
		mask="(###) ###-####"
		:disabled="disabled"
		:readonly="readonly"
		:required="required"
		rules="phone"
		@input="onInput"
		@focus="$emit('focus', $event)"
		@blur="$emit('blur', $event)"
		@change="$emit('change', $event)"
		validation-mode="eager" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { TextInput } from '..';
import { makeProp } from '@/utils/props';
import Props, { MaybeProp } from '@/support/constants/props';


export default defineComponent({
	name: "PhoneInput",
	components: {
		TextInput
	},
	props: {
		id: makeProp(Props.String, undefined, true),
		name: {
			type: String,
			default: 'phone_number'
		},
		value: makeProp(Props.String as MaybeProp<string>),
		required: makeProp(Props.Boolean),
		readonly: makeProp(Props.Boolean),
		label: makeProp(Props.String, 'Phone Number'),
		disabled: makeProp(Props.Boolean),
	},
	methods: {
		onInput(value: string) {
			const newvalue = value.replace(/\D/g, "");
			this.$emit('input', newvalue);
		}
	}
})
</script>
